import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

export const ADMIN_PRODUCTS_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/products`;

export const ADMIN_PRODUCTS_API_PATHS = {
  GET_PRODUCTS: `${ADMIN_PRODUCTS_API_ROOT}`,
  CREATE_PRODUCT: `${ADMIN_PRODUCTS_API_ROOT}`,
  GET_PRODUCT_BY_ID: (productId: string) => `${ADMIN_PRODUCTS_API_ROOT}/${productId}`,
  UPDATE_PRODUCT: (productId: string) => `${ADMIN_PRODUCTS_API_ROOT}/${productId}`,
  ARCHIVE_PRODUCT: (productId: string) => `${ADMIN_PRODUCTS_API_ROOT}/${productId}`,
  RESTORE_PRODUCT: (productId: string) => `${ADMIN_PRODUCTS_API_ROOT}/${productId}/restore`,
  UPDATE_POSITIONS: `${ADMIN_PRODUCTS_API_ROOT}/positions`,
  GET_UPLOAD_URL: `${ADMIN_PRODUCTS_API_ROOT}/upload-url`,
};
